import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { Suspense, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import NavBar from './NavBar';
import TopBar from './TopBar';
import NavBarContext from 'src/contexts/NavBarContext';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    paddingTop: 0,
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0
    }
  }
}));

function Dashboard({ route }) {
  const classes = useStyles();
  const [openNavBar, setOpenNavBar] = useState(false);

  const closeNavBar = () => setOpenNavBar(false);

  return (
    <NavBarContext.Provider value={{ openNavBar, setOpenNavBar, closeNavBar }}>
      <TopBar onOpenNavBar={() => setOpenNavBar(!openNavBar)} />
      <NavBar
        onClose={() => setOpenNavBar(!openNavBar)}
        open={openNavBar}
      />
      <div className={classes.container}>
        <div
          className={classes.content}
          style={{ paddingLeft: openNavBar ? 300 : 0 }}
        >
          <Suspense fallback={<LinearProgress />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </div>
      </div>
    </NavBarContext.Provider>
  );
}

Dashboard.propTypes = {
  route: PropTypes.object
};

export default Dashboard;
